import React from "react";
import Button from "../../../shared/button/button";
import { formatCurrency } from "../../../../js/shared/utils";
import { formatDateToLocalDate } from "../../../js/shared/utils";

const SaleDetailsInfoPanel = ({ item, ...props } = props) => {
	return (
		<div className="sale-details-info-panel">
			<div className="sale-details-info-panel__fidelity-info">
				<div className="row sale-details-info-panel__fidelity-info__block">
					<div className="col-xs-16 col-sm-3 sale-details-info-panel__fidelity-info__block--one">
						<h3>{item.fidelityName}</h3>
						<p>
							<span>Transação: </span>
							{item.transaction}
						</p>
						<p>
							<span>Venda: </span>
							{formatDateToLocalDate(item.saleDate)}
						</p>
						<p>
							<span>Pagamento: </span>
							{formatDateToLocalDate(item.paymentDate)}
						</p>
						<p>
							<span>Localizador: </span>
							{item.localizator}
						</p>
					</div>

					<div className="col-xs-16 col-sm-8 sale-details-info-panel__fidelity-info__block--two">
						<div className="font-size-large d-flex">
							<div>
								<i className="icon-credit" />
								{item.miles} milhas
							</div>
							<div className="font-weight-bold">{formatCurrency(item.total)}</div>
						</div>

						<div className="font-size-normal">
							<div className="pull-left">
								Taxas de embarque <br />e bagagem
							</div>
							<div className="pull-right">
								Pagas pela <br />Maxmilhas
							</div>
						</div>
						<hr className="sale-details-info-panel--dotted" />

						<div className="font-weight-normal font-size-big">
							<div className="pull-left">Total a receber:</div>
							<div className="pull-right">{formatCurrency(item.total)}</div>
						</div>

						<hr className="sale-details-info-panel--dotted" />

						<div className="font-size-small">
							<div className="pull-left">1.000 milhas: {formatCurrency(item.price)}</div>
						</div>
					</div>

					<div className="col-xs-16 col-sm-3">
						<div className="sale-details-info-panel--block-close">
							<small>Ocultar detalhes </small>{" "}
							<i
								className="icon-close"
								onClick={props.close}
								data-action="sale-details-info-panel-hide"
							/>
						</div>
						<div className="sale-details-info-panel__fidelity-info__block--three">
							<Button
								className="btn-green-md-s"
								data-action="sale-details-info-panel-inconsistency"
							>
								<span className="font-weight-light font-size-normal">Inconsistência?</span>
							</Button>
							<Button className="btn-green-md-s" data-action="sale-details-info-panel-change">
								<span className="font-weight-light font-size-normal">Alteração do voo</span>
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SaleDetailsInfoPanel;
